module.exports = __webpack_public_path__ + "img/symbol_8.a99dd55c.png";